export default __webpack_public_path__ + "static/media/Porqué ocupar glup Tickets en tus eventos.39be4237.pdf";